import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type DeleteTwilioSubAccountPayload = {
  dealer_id: number;
};

type DeleteTwilioSubAccountResponse = {
  api_key: string;
  api_secret: string;
};

export const useGenerateTwilioApiKeyMutation = () =>
  useTypedMutation<DeleteTwilioSubAccountPayload, DeleteTwilioSubAccountResponse>({
    mutationFn: async payload => (await ApiInstance.post("/sub_accounts/generate_api_key", payload, ENV.twilioBaseURL)).data,
    onSuccess: (payload, response) => {
      const dealerUpdate = { twilio_api_key: response.api_key, has_twilio_api_secret: Boolean(response.api_secret), is_twilio_sub_account_managed: true };

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...dealerUpdate })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (!selectedDealer) return;

      setSelectedDealer({ ...selectedDealer, ...dealerUpdate });
    }
  });
